<template>
  <button
    type="button"
    class="btn btn-link btn-sm text-decoration-none p-0"
    @click="modalRef?.toggleModal()"
  >
    <font-awesome-icon icon="circle-info" class="me-1" />
    How is this calculated?
  </button>
  <ModalComponent
    ref="modalRef"
    submitButtonText="Close"
    :hideSubmitButton="true"
    size="lg"
  >
    <template #title>{{ title }}</template>
    <template #body>
      <div class="p-3 methodology">
        <slot />
      </div>
    </template>
    <template #footer>
      <button class="btn btn-secondary" @click="modalRef?.toggleModal()">
        Close
      </button>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
import ModalComponent from "@/components/common/ModalComponent.vue";
import { useTemplateRef } from "vue";

/**
 * Inline "How is this calculated?" trigger plus the modal it opens. Put the explanation in the
 * default slot; keep it in plain language and name the backend fields it maps to.
 */
defineProps<{
  title: string;
}>();

const modalRef =
  useTemplateRef<InstanceType<typeof ModalComponent>>("modalRef");
</script>

<style scoped lang="scss">
.methodology :deep(dl) {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 0.25rem 1rem;
}

.methodology :deep(dt) {
  font-weight: 600;
}

.methodology :deep(dd) {
  margin-bottom: 0;
}
</style>
